import { GridRow } from '../../../../types/types';

export type ConditionalSubset = {
  datasetId: string;
  label?: string;
  hint?: string;
  visibleWhen?: {
    field: string;
    equals: string | number | boolean;
  };
  [key: string]: unknown;
};

export const getVisibleSubsets = <T extends ConditionalSubset>(
  subsets: T[] | undefined,
  parentRow: GridRow
): T[] =>
  (subsets ?? []).filter((subset) => {
    if (!subset.visibleWhen) return true;
    return parentRow?.[subset.visibleWhen.field] === subset.visibleWhen.equals;
  });
